


export const diagnosticoMapper = ( diagnostico ) => {

  if( !diagnostico ) return null;

  return  diagnostico.map( item => ({
    id        : item.id,
    principal : item.esprincipal === '1',
    diagnostico : {
      value: item.diagnostico.id, 
      text: `(${item.diagnostico.codigo}) ${item.diagnostico.descripcion}`,
      codigo: item.diagnostico.codigo
    },
    tipo : { 
      value: item.tipoDiagnostico?.id, 
      text: item.tipoDiagnostico?.descripcion || 'No definido'
    },

    activo : item.estado === '1'
  }));
}
